import { preguntas } from "@/shared/dtos/preguntas";

export class pregunta_for_mappeo extends preguntas {
  public nombre_mapeo!: string;
}
